module.exports = __webpack_public_path__ + "static/media/remixicon.dc0fb3e9.eot";